import { useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./app.css";
import "react-loading-skeleton/dist/skeleton.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer, Zoom  } from "react-toastify";
import Dashboard from "./Pages/Dashboard";
import Attribute from "./Pages/Attribute/Attribute";
import Categories from "./Pages/Categories/Categories";
import Banners from "./Pages/Banners/Banners";
import Coupons from "./Pages/Coupons/Coupons";
import Setting from "./Pages/Setting/Setting";
import Permissions from "./Pages/Permission/Permissions"; 
import ProductsDetails from "./ComponentsWeb/Sub/ProductsDetails";
import Home from "./ComponentsWeb/Main/Home";
import Reviews from "./Pages/Review/Reviews";
import About from "./ComponentsWeb/Main/About";
import Contact from "./ComponentsWeb/Main/Contact";
import Shop from "./ComponentsWeb/Sub/Shop";
import Checkout from "./ComponentsWeb/Main/Checkout";
import Response from "./ComponentsWeb/Main/Response";
import UserLogin from "./ComponentsWeb/Main/user/UserLogin";
import UserSignup from "./ComponentsWeb/Main/user/UserSignup";
import AddProduct from "./Pages/Products/AddProduct";
import AddUserAddress from "./ComponentsWeb/Main/user/AddUserAddress";
import UserPanel from "./ComponentsWeb/Main/user/UserPanel";
import OrdersList from "./Pages/Orders/OrdersList";
import SocialMediaSetting from "./Pages/SocialMediaSetting";
import ProductsList from "./Pages/Products/ProductsList";
import EmailTemplates from "./Pages/EmailTemplates/EmailTemplates";
import Pages from "./Pages/infoPages/Pages";
import DynamicPages from "./Components/DynamicPages";
import UpdateProduct from "./Pages/Products/UpdateProduct";
import TaxClasses from "./Pages/TaxClasses/TaxClasses";
import ForgotPassword from "./ComponentsWeb/Main/user/forgotpassword/ForgotPassword";
import VerifyOtp from "./ComponentsWeb/Main/user/forgotpassword/VerifyOtp";
import NewPassword from "./ComponentsWeb/Main/user/forgotpassword/NewPassword";
import ShippingChargesList from "./Pages/ShippingCharges/ShippingChargesList";
import UserOrderReper from "./Pages/Orders/UserOrderReper";
import TrackersList from "./Pages/Trackers/TrackersList";
import UsersCartList from "./Pages/UsersCart/UsersCartList";
import OffersList from "./Pages/Offers/OffersList";
import RewardSlabList from "./Pages/RewardSlab/RewardSlabList";
import Users from "./Pages/User/Users"
// import PaymentOptions from "./ComponentsWeb/Main/PaymentOptions";
import UserAddress from "./ComponentsWeb/Main/user/UserAddress";
import RegisterWithPhone from "./ComponentsWeb/Main/user/RegisterWithPhone";
import ProductLabelList from "./Pages/ProductLabels/ProductLabelList";
import WarehouseList from "./Pages/Warehouse/WarehouseList";
import FileSettingList from "./Pages/FileSettings/FileSettingList";
import OrderFiles from "./Pages/ShippingTool/OrderFiles";
import ProductFieldAction from "./Pages/Products/ProductFieldAction";
import PackageList from "./Pages/Package/PackageList";
import InvoiceFiles from "./Pages/Invoice/InvoiceFiles";
import CodList from "./Pages/Cod/CodList";
import UserAdminOrderDetails from "./Pages/Orders/UserAdminOrderDetails";
import ThankYouPage from "./ComponentsWeb/Sub/ThankYouPage";
import PendingOrders from "./Pages/Orders/PendingOrders";
import AdminUserAddress from "./Pages/User/AdminUserAddress";
import { currentPath, addProductUrl, adminUserAddressUrl, attributesUrl, bannerUrl, categoriesUrl, checkerUrl, codListUrl, couponsUrl, customizeProductImgUrl, dashboardUrl, EmailTemplatesUrl, fileSettingsUrl, infoPagesUrl, invoicePdfUrl, loginUrl, managerUrl, offersUrl, orderDetailsUrl, orderPdfUrl, ordersUrl, packageListUrl, pendingOrdersUrl, permissionsUrl, productEditUrl, productLabelsUrl, productListUrl, reviewsUrl, rewardSlabUrl, settingsUrl, shippingChargesUrl, socialMediaSettingUrl, taxClassesUrl, trackersUrl, usersUrl, vendorUrl, warehouseUrl, dashboardReportUrl, userCartList, shippingLogsUrl, crossSelling, videosUrl, orderExport } from "./const";
import DashboardReport from "./Pages/DashboardReport";
import ShippingLogs from "./Pages/ShippingTool/ShippingLogs";
import CrossSellingList from "./Pages/CrossSelling/CrossSellingList";
import OrderThread from "./ComponentsWeb/Main/user/OrderThread";
import Video from "./Pages/Vidoes/Video";
import SmsErrorLogs from "./ComponentsWeb/Main/SmsErrorLogs";
import ExportOrderList from "./Pages/OrderExport/ExportOrderList";
import NetworkChecker from "./Components/NetworkChecker";
// import NetworkChecker from "./Components/NetworkChecker";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source");
  const utmMedium = urlParams.get("utm_medium");
  const utmCampaign = urlParams.get("utm_campaign");
  const utmAdsetname = urlParams.get("utm_adsetname");
  const utmAdname = urlParams.get("utm_adname");
  //check order source
  useEffect(() => {
    if (utmSource && utmMedium) {
      localStorage.setItem("utm_source", utmSource);
      localStorage.setItem("utm_Medium", utmMedium);
      localStorage.setItem("utm_campaign", utmCampaign);
      localStorage.setItem("utm_adsetname", utmAdsetname);
      localStorage.setItem("utm_adname", utmAdname);
    }
  },[utmSource, utmMedium, utmCampaign, utmAdsetname, utmAdname])
  //end check order source
  const getTimeUntilMidnight = () => {
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setHours(23, 59, 59, 999);
    if (now > tomorrow) {
      tomorrow.setDate(tomorrow.getDate() + 7);
    }
    return tomorrow - now; 
  };
  const clearLocalStorageAtMidnight = () => {
    Object.keys(localStorage).forEach((key) => {
      // if (key !== "x-auth-token" && key !== "slug" && key !== "userRole" && key !== "username") {
        localStorage.removeItem(key);
      // }
    });
    const timeUntilNextMidnight = getTimeUntilMidnight();
    setTimeout(clearLocalStorageAtMidnight, timeUntilNextMidnight);
  };
  useEffect(() => {
    const timeUntilNextMidnight = getTimeUntilMidnight();
    const timer = setTimeout(clearLocalStorageAtMidnight, timeUntilNextMidnight);
    return () => clearTimeout(timer);
  }, []);

  const PrivateRoute = ({ children, allowedRoles  }) => {
    const isAuthenticated = (((localStorage.getItem("slug") === "admin") || (localStorage.getItem("slug") === "checker")) && currentPath?.includes('/admin/')) ? !!localStorage.getItem('x-admin-token') : !!localStorage.getItem('x-auth-token'); // or any other auth logic
    const userRole = localStorage.getItem("slug");
    if (!isAuthenticated) {
      return <Navigate to="/" replace />; 
    }
    if (allowedRoles && !allowedRoles.includes(userRole)) {
      return <Navigate to="/" replace />; 
    }
    return children;
  };
  
  if (window.location.hostname === 'www.ranbazaar.com') {
    window.location.replace('https://ranbazaar.com' + window.location.pathname + window.location.search);
}
  return (
    <>
      {/* <NetworkChecker/> */}
      <Routes>
        {/* web routes start*/}
        <Route path="/" element={<Home />} /> 
         <Route path="/no-internet" element={<NetworkChecker />} /> 
        <Route path="/response" element={<Response />} />
        <Route path="/thankyou" element={<ThankYouPage />} />
        <Route path="/product/:slug" element={<ProductsDetails />} />
        <Route path="/shop/:slug" element={<Shop />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Shop />} />
        {/* <Route path="/login" element={<UserLogin />} /> */}
        <Route path="/signup" element={<UserSignup />} />
        <Route path="/user-address" element={<UserAddress />} />
        <Route path="/add-user-address" element={<AddUserAddress />} />
        <Route path="/user-dashboard" element={<UserPanel />} />
        <Route path="/order-thread" element={<OrderThread />} />
        <Route path="/contact" element={<Contact />} />
         <Route path="/sms-error" element={<SmsErrorLogs />} />
        <Route path="/:slug" element={<DynamicPages />} />
        <Route path="/phone-verify" element={<RegisterWithPhone />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/create-new-password" element={<NewPassword />} />
        {/* web routes end*/}
        <Route path="/order" element={<PrivateRoute><UserOrderReper /></PrivateRoute>} />
        {/* <Route path="/admin" > */}
         <Route path={loginUrl} element={<UserLogin />} />
         <Route path={userCartList} element={<PrivateRoute allowedRoles={["admin"]}><UsersCartList /></PrivateRoute>} />
         <Route path={dashboardUrl} element={<PrivateRoute allowedRoles={["admin"]}><DashboardReport /></PrivateRoute>} />
         <Route path={dashboardReportUrl} element={<PrivateRoute allowedRoles={["admin"]}><Dashboard /></PrivateRoute>} />
         <Route path={`/admin/product/:slug`} element={<ProductsDetails />} />
         <Route path={usersUrl} element={<PrivateRoute allowedRoles={["admin"]}><Users /></PrivateRoute>} />
         <Route path={adminUserAddressUrl} element={<PrivateRoute allowedRoles={["admin"]}><AdminUserAddress /></PrivateRoute>} />
         <Route path={rewardSlabUrl} element={<PrivateRoute allowedRoles={["admin"]}><RewardSlabList /></PrivateRoute>} />
         <Route path={managerUrl} element={<PrivateRoute allowedRoles={["admin"]}><Users /></PrivateRoute>} />
         <Route path={checkerUrl} element={<PrivateRoute allowedRoles={["admin"]}><Users /></PrivateRoute>} />
         <Route path={trackersUrl} element={<PrivateRoute allowedRoles={["admin"]}><TrackersList /></PrivateRoute>} />
         <Route path={ordersUrl} element={<PrivateRoute allowedRoles={["admin", 'checker']}><OrdersList /></PrivateRoute>} />
         <Route path={pendingOrdersUrl} element={<PrivateRoute allowedRoles={["admin"]}><PendingOrders /></PrivateRoute>} />
         <Route path={orderDetailsUrl} element={<PrivateRoute><UserAdminOrderDetails /></PrivateRoute>} />
         <Route path={EmailTemplatesUrl} element={<PrivateRoute allowedRoles={["admin"]}><EmailTemplates /></PrivateRoute>} />
         <Route path={categoriesUrl} element={<PrivateRoute allowedRoles={["admin"]}><Categories /></PrivateRoute>} />
         <Route path={bannerUrl} element={<PrivateRoute allowedRoles={["admin"]}><Banners /></PrivateRoute>} />
         <Route path={videosUrl} element={<PrivateRoute allowedRoles={["admin"]}><Video /></PrivateRoute>} />
         <Route path={vendorUrl} element={<PrivateRoute allowedRoles={["admin"]}><Users /></PrivateRoute>} />
         <Route path={couponsUrl} element={<PrivateRoute allowedRoles={["admin"]}><Coupons /></PrivateRoute>} />
         <Route path={settingsUrl} element={<PrivateRoute allowedRoles={["admin"]}><Setting /></PrivateRoute>} />
         <Route path={permissionsUrl} element={<PrivateRoute allowedRoles={["admin"]}><Permissions /></PrivateRoute>} />
         <Route path={reviewsUrl} element={<PrivateRoute allowedRoles={["admin"]}><Reviews /></PrivateRoute>} />
         <Route path={addProductUrl} element={<PrivateRoute allowedRoles={["admin"]}><ProductFieldAction /></PrivateRoute>} />
         <Route path={customizeProductImgUrl} element={<PrivateRoute allowedRoles={["admin"]}><AddProduct /></PrivateRoute>} />
         <Route path={productLabelsUrl} element={<PrivateRoute allowedRoles={["admin"]}><ProductLabelList /></PrivateRoute>} />
         <Route path={packageListUrl} element={<PrivateRoute allowedRoles={["admin"]}><PackageList /></PrivateRoute>} />
         <Route path={codListUrl} element={<PrivateRoute allowedRoles={["admin"]}><CodList /></PrivateRoute>} />
         <Route path={fileSettingsUrl} element={<PrivateRoute allowedRoles={["admin"]}><FileSettingList /></PrivateRoute>} />
         <Route path={warehouseUrl} element={<PrivateRoute allowedRoles={["admin"]}><WarehouseList /></PrivateRoute>} />
         <Route path={productListUrl} element={<PrivateRoute allowedRoles={["admin"]}><ProductsList /></PrivateRoute>} />
         <Route path={productEditUrl} element={<PrivateRoute allowedRoles={["admin"]}><UpdateProduct /></PrivateRoute>} />
         <Route path={infoPagesUrl} element={<Pages />} />
         <Route path={orderPdfUrl} element={<PrivateRoute allowedRoles={["admin"]}><OrderFiles /></PrivateRoute>} />
         <Route path={orderExport} element={<PrivateRoute allowedRoles={["admin"]}><ExportOrderList /></PrivateRoute>} />
         <Route path={invoicePdfUrl} element={<PrivateRoute allowedRoles={["admin"]}><InvoiceFiles /></PrivateRoute>} />
         <Route path={attributesUrl} element={<PrivateRoute allowedRoles={["admin"]}><Attribute /></PrivateRoute>} />
         <Route path={socialMediaSettingUrl} element={<PrivateRoute allowedRoles={["admin"]}><SocialMediaSetting /></PrivateRoute>} />
         <Route path={taxClassesUrl} element={<PrivateRoute allowedRoles={["admin"]}><TaxClasses /></PrivateRoute>} />
         <Route path={shippingChargesUrl} element={<PrivateRoute allowedRoles={["admin"]}><ShippingChargesList /></PrivateRoute>} />
         <Route path={crossSelling} element={<PrivateRoute allowedRoles={["admin"]}><CrossSellingList /></PrivateRoute>} />
         <Route path={shippingLogsUrl} element={<PrivateRoute allowedRoles={["admin"]}><ShippingLogs /></PrivateRoute>} />
         <Route path={offersUrl} element={<PrivateRoute allowedRoles={["admin"]}><OffersList /></PrivateRoute>} />
        {/* </Route> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer
          position="bottom-center"
          autoClose={500}
          hideProgressBar
          newestOnTop={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Zoom}
        />
       {/* {currentUrl.includes(!'shop') && <GoToTop />} */}
    </>
  );
}
export default App;
